import { InputWithLabel } from '@adotel/components'
import SearchIcon from '@material-ui/icons/Search'

import { getTranslate } from '../../localization'
import useStyles from './styles/GatewayFilters.styles'

interface GatewayFiltersProps {
  inputValue: string
  setinputValue: React.Dispatch<React.SetStateAction<string>>
}

const GatewaysFilters: React.FC<GatewayFiltersProps> = ({
  inputValue,
  setinputValue
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <InputWithLabel
        placeholder={getTranslate('Search by name or property code')}
        autoComplete="off"
        noHelperText
        fullWidth
        startIcon={<SearchIcon />}
        className={classes.searchInput}
        value={inputValue}
        onChange={(event) => {
          setinputValue(event.currentTarget.value)
        }}
      />
    </div>
  )
}

export default GatewaysFilters
